<template>
  <div class="bg-white" style="position: inherit">
    <template v-if="!ifEmptyHide">
    <div
      v-if="!detailSetting.boxSetting.hideToolbar"
      class="detail-content-header"
    >
      <nav class="navbar wd-100p pd-0">
        <nav class="nav">
          <div
            class="nav-link dropdown"
            v-if="prms.boxChooser != undefined && prms.boxChooser"
          >
            <span
              class="dropdown-toggle"
              type="button"
              id="dropdownMenuButton"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <feather class="wd-20 ht-20" type="menu"></feather>Бүрдэлүүд
            </span>

            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <!-- <h6 class="dropdown-header tx-uppercase tx-12 tx-bold tx-inverse">Бүрдэлүүд</h6> -->
              <a
                :class="{ 'active text-white': b.id == box.id }"
                :key="i"
                v-for="(b, i) in parentTask.b"
                class="dropdown-item"
                role="button"
                @click="$emit('load-box', b)"
                >{{ b.nm }}</a
              >
            </div>
          </div>
          <!-- <div class="nav-link dropdown">
            <ul class="dropdown-menu" aria-labelledby="dropdownMenuBox">
              <li
                class="dropdown-item"
                role="button"
                @click="$emit('on-box-edit', box)"
              >
                Засах
              </li>
              <li
                class="dropdown-item tx-danger"
                role="button"
                @click="$emit('on-box-delete', box)"
              >
                Устгах
              </li>
            </ul>
            <div id="dropdownMenuBox" data-toggle="dropdown" role="button">
              <button
                class="btn btn-xs btn-outline-primary btn-uppercase mg-r-10"
              >
                <feather
                  type="tool"
                  class="ht-15-f wd-16-f mg-r-5"
                  style="float: left"
                ></feather
                >тохиргоо
              </button>
            </div>
          </div> -->
        </nav>
        <div
          class="text-truncate"
          style="max-width: 50%"
          :title="box.nm"
        >
          {{ box.nm }}
        </div>
        <div class="mg-l-auto d-flex align-items-center">
        <template v-if="box.ot!=343">
          <task-finder v-show="!hasPermission(['elf_student'])"
            v-if="
              box.settingFlag != -100 || $store.state.app.activeGroup.id == 9132
            "
            @on-task-selected="taskAttached"
            class="pd-x-5 mg-b-10"
            boxChooser
            :showChooser="!(box.ot==397 || box.ot==502 || box.ot==124 || box.ot==461 || box.ot==524)"
            :mode="-100"
            :objectTypeId="`${box.ot}`"
            sidebarWidth="calc(100% - 60px)"
          ></task-finder>
          <button
            v-if="tasks.filter(x => x.selcd).length == 1"
            @click="detachTaskFromBox(tasks.filter(x => x.selcd)[0].id)"
            class="btn btn-xs btn-outline-danger btn-uppercase mg-r-10 core-box-action-unlink"
          >
            <feather type="link-2"></feather>Холболт салгах
          </button>
          <button v-if="!(box.ot==502)"
            @click="
              $emit('show-edit', {
                id: 0,
                projectId: box.projectId,
                objectTypeId: box.ot,
                boxId: box.id,
                mode: 2
              })
            "
            class="btn btn-xs btn-outline-primary btn-uppercase"
          >
            <feather type="plus-square" class="mg-r-5"></feather>нэмэх
          </button>
        </template>
          <button v-show="!hasPermission(['elf_student'])"
            @click="showBoxFilter()"
            class="btn btn-xs btn-outline-light btn-uppercase mg-l-10"
          >
            <feather type="search" class="mg-r-5"></feather>Хайх / Экспорт
          </button>
        </div>
      </nav>
    </div>
    <!-- {{ tasksCount }} -->
    <div v-if="!fetched" class="pd-x-20 pd-y-10">
      <div class="container d-flex justify-content-center ht-100p">
        <div
          class="mx-wd-300 wd-sm-450 ht-100p d-flex flex-column align-items-center justify-content-center pd-t-100"
        >
          <div class="wd-80p wd-sm-300 mg-b-15">
            <img src="assets/svg/content.svg" class="img-fluid" alt />
          </div>
          <h4 class="tx-20 tx-sm-24 text-muted">Түр хүлээнэ үү</h4>
          <p class="tx-color-03 mg-b-30 tx-center">
            Мэдээл боловсруулж байна ...
          </p>
        </div>
      </div>
    </div>
    <div v-else class>
      <div v-if="tasksCount > 0 || allCount > 0 || 1==1">
        <div ref="listHeader" class="row no-gutters bd-b bg-light d-flex ht-50">
          <div
            class="wd-5p justify-content-center align-items-center d-flex text-muted"
          >
            #
          </div>
          <div
            :class="
              `tx-12 align-items-center d-flex pd-y-3 text-muted bd-l`
            "
            :style="`width: ${f.span}%;  `"
            v-for="(f, i) in fields"
            :key="i"
          >
            <span :alt="f.title" :title="f.title" class="pd-x-5" style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">{{ f.title }}</span>
          </div>
        </div>
        <vue-custom-scrollbar
          class="bg-white"
          :style="`height:${detailSetting.boxSetting.listSetting.height}`"
          :settings="{ maxScrollbarLength: 60 }"
        >
          <div @contextmenu.prevent="showMenu($event, t)"
            @click.stop="showDetail(t)"
            class="row highlight no-gutters bd-b"
            v-for="(t, i) in tasks.filter(
              x => x.hidden == undefined || !x.hidden
            )"
            :key="i"
            role="button"
          >
            <div
              class="wd-5p justify-content-center align-items-center d-flex pd-y-10"
            >
              <img v-if="t.systemFlag==999999999" src="https://res.gosmart.mn/media/logo/emongolia.png?w=20" />
              <input v-else
                @click.stop="boxRowSelect(t)"
                v-model="t.selcd"
                type="checkbox"
              />
            </div>
            <dynamic-cell
              @on-update-field="updateField"
              @on-attach="$emit('on-attach', $event)"
              @show-detail="$emit('on-detail', t, 80)"
              @on-user-info="handleUserInfoModal"
              :name="t.id + '_' + i"
              :t="t"
              :f="f"
              :projectStat="projectStat"
              :nowDate="nowDate"
              :parentTask="parentTask"
              :style="`width: ${f.span}%; overflow: hidden`"
              v-for="(f, i) in fields"
              :key="i"
              @link-drive="showFinder"
            ></dynamic-cell>
          </div>
          <div v-if="!detailSetting.boxSetting.hideFooter" class="pd-10 d-flex">
            <div>
              Нийт:
              {{
                tasksCount != allCount
                  ? tasksCount + "/" + allCount
                  : tasksCount
              }}
            </div>
            <!-- <div class="btn-group">
              <button class="btn btn-outline-light btn-xs btn-uppercase">Хайх</button>
              <button class="btn btn-outline-light btn-xs btn-uppercase">Татах</button>
            </div> -->

            <b-pagination
              class="mg-l-auto"
              size="sm"
              align="right"
              v-model="pager.current"
              :total-rows="tasksCount"
              :per-page="pager.perPage"
              @change="pageChanged"
              style="margin-bottom: 0"
            ></b-pagination>
          </div>
        </vue-custom-scrollbar>

        <b-overlay :show="busy" no-wrap>
          <template #overlay>
            <div
              v-if="processing"
              class="p-4 text-center rounded bg-secondary text-light"
            >
              <b-icon icon="info" font-scale="4"></b-icon>
              <div class="mb-3">Түр хүлээнэ үү...</div>
              <b-progress
                min="1"
                max="20"
                :value="18"
                variant="warning"
                height="5px"
                class="mx-n4 rounded-0"
              ></b-progress>
            </div>
            <div
              v-else
              ref="dialog"
              tabindex="-1"
              role="dialog"
              aria-modal="false"
              aria-labelledby="form-confirm-label"
              class="p-3 text-center"
            >
              <p>
                <strong id="form-confirm-label">Итгэлтэй байна уу?</strong>
              </p>
              <div class="d-flex">
                <b-button
                  variant="outline-danger"
                  class="mr-3"
                  @click="busy = false"
                  >Үгүй</b-button
                >
                <b-button
                  variant="outline-success"
                  @click="processConfirm()">Тийм</b-button
                >
              </div>
            </div>
          </template>
        </b-overlay>
      </div>
      <div v-else-if="!detailSetting.boxSetting.hideEmptyTemplate">
        <div class="container d-flex justify-content-center ht-100p">
          <div
            :style="`height:${detailSetting.boxSetting.listSetting.height}`"
            class="mx-wd-300 wd-sm-450 ht-100p d-flex flex-column align-items-center justify-content-center pd-t-100"
          >
            <div class="wd-80p wd-sm-300 mg-b-15">
              <img src="assets/svg/boxempty.svg" class="img-fluid" alt />
            </div>
            <h4 class="tx-20 tx-sm-24 text-muted">Мэдээлэл хоосон байна</h4>
            <p class="tx-color-03 mg-b-30 tx-center">
              Та эрх бүхий хэрэглэгч бол шинэ товч дарж шинээр бүртгэх
              боломжтой.
            </p>
          </div>
        </div>
      </div>
    </div>

    <media-finder
      v-if="mediaFinder.show > 0"
      @on-attach="fileAttached"
      @on-task-close="mediaFinder.show = 0"
    ></media-finder>

    <b-modal
      title="Хайх"
      v-model="boxFilter.modal"
      no-close-on-backdrop
      scrollable
    >
      <task-searches
        ref="srchFields"
        :allCount="allCount"
        :tasksCount="tasksCount"
        :searches="boxFilter.searches"
        @on-search="onSearchFired"
        @on-export="exportBox"
      ></task-searches>
      <template #modal-footer>
        <div v-show="allCount != tasksCount">
          Хайлтын үр дүн: {{ tasksCount }}/{{ allCount }}
        </div>
        <div class="mg-l-auto btn-group">
          <button
            @click="exportBoxHandle()"
            type="button"
            class="btn btn-success btn-xs btn-uppercase"
          >
            Экспорт
          </button>
          <button
            @click="filterCoreBox(false)"
            type="button"
            class="btn btn-primary btn-xs btn-uppercase"
          >
            Хайх
          </button>
          <button
            @click="filterCoreBox(true)"
            type="button"
            class="btn btn-light btn-xs btn-uppercase"
          >
            Бүгд
          </button>
        </div>
      </template>
    </b-modal>

    <b-modal
      title="Цаг тохируулах"
      v-model="pointObj.modal"
      no-close-on-backdrop
      scrollable
    >
    <form class="el-form">
      <div class="el-form-item">
        <label for="task" class="el-form-item__label" style="width: 30%;">Орох цаг</label>
        <div class="el-form-item__content" style="margin-left: 30%;">
          <div class="el-input">
            <input v-model="pointObj.count" type="number" autocomplete="off" placeholder="" class="el-input__inner">
          </div>
        </div>
      </div>
      <div class="el-form-item">
        <label for="task" class="el-form-item__label" style="width: 30%;">Орсон цаг</label>
        <div class="el-form-item__content" style="margin-left: 30%;">
          <div class="el-input">
            <input v-model="pointObj.price" type="number" autocomplete="off" placeholder="" class="el-input__inner">
          </div>
        </div>
      </div>
    </form>
      <template #modal-footer>
        <div class="mg-l-auto btn-group">
          <button
          @click="pointObj.modal=false"
            type="button"
            class="btn btn-white btn-xs btn-uppercase"
          >
            Хаах
          </button>
          <button
          @click="postBoxInTaskOption()"
            type="button"
            class="btn btn-white btn-xs btn-uppercase"
          >
            Хадгалах
          </button>
        </div>
      </template>
    </b-modal>

    </template>

    <div v-if="isMenuVisible" :style="{ top: `${menuPosition.y}px`, left: `${menuPosition.x}px` }" 
      class="z-50 bg-white rounded shadow-lg pos-fixed bd-gray-300" style="z-index: 50">
      <ul class="rounded list-group wd-200">
        <li class="list-group-item" role="button" @click="handleMenuItemClick('detail')"><feather type="mouse-pointer" class="mg-r-5"></feather>Дэлгэрэнгүй</li>
        <!-- <li class="list-group-item" role="button" @click="handleMenuItemClick('edit')"><feather type="edit" class="mg-r-5"></feather>Засах</li> -->
        <li class="list-group-item text-danger" role="button" @click="handleMenuItemClick('delete')"><feather type="trash-2" class="mg-r-5"></feather>Устгах</li>
      </ul>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";

import {
  coreBoxInTaskList,
  getListFields,
  getSearchFields
} from "@/api/taskCore";
import {
  getInheritedTask,
  postInheritedTask,
  taskInheritedDetail
} from "@/api/task";

import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
import vueCustomScrollbar from "vue-custom-scrollbar";

import { hasOneOf } from "@/libs/tools";
import { request } from "@/api/all";

export default {
  components: {
    vueCustomScrollbar,
    taskSearches: () => ({
      component: import("@/components/project/searches.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    dynamicCell: () => ({
      component: import("@/components/task/list/components/cell"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    mediaFinder: () => ({
      component: import("@/components/modules/media/finder"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    taskFinder: () => ({
      component: import("@/components/task/edit/components/taskFinder"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    })
  },
  props: {
    parentTask: {
      type: Object,
      default: () => {}
    },
    box: {
      type: Object,
      default: () => {}
    },
    prms: {
      type: Object,
      default: () => {}
    },
    obj: {
      type: Object,
      default: () => {}
    },
    activeBox: {
      type: Object,
      default: () => {}
    },
    detailSettingProp: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      ifEmptyHide: false,
      pointObj:{
        count: 0,
        price: 0,
        taskId: null,
        modal: false,
      },
      detailSetting: {
        boxSetting: {
          hideToolbar: false,
          hideAddButton: false,
          hideEmptyTemplate: false,
          hideFooter: false,
          listSetting: {
            height: 300,
            disableDetail: false
          }
        }
      },

      fetched: false,
      tasks: [],
      allCount: 0,
      tasksCount: 0,
      task: {},
      fields: [],

      nowDate: "",
      projectStat: {},
      mediaFinder: {
        show: false,
        id: 0,
        key: 0
      },
      linkAttaching: {
        taskId: 0,
        field: ""
      },
      processing: false,
      busy: false,
      processingObj: 0,
      processingMode: 0,
      taskCur: {
        id: 0
      },
      pager: {
        perPage: 20,
        current: 1
      },
      boxFilter: {
        searches: [],
        modal: false,
        searchesKey: 0
      },
      coreSearchModel: {},
      isMenuVisible: false,
      menuPosition: { x: 0, y: 0 },
      selectedItem: null
    };
  },
  mounted() {
    document.addEventListener('click', () => {
      if (this.isMenuVisible) {
        this.isMenuVisible = false;
      }
    });

    require("@/assets/css/dynamic.detail.css");
    this.initFields();
    if (this.detailSettingProp != null) {
      let tmp = this.detailSetting;
      this.detailSetting = this.detailSettingProp;
      if (this.detailSettingProp.boxSetting == undefined) {
        this.detailSetting.boxSetting = tmp.boxSetting;
      }
    }

    window.addEventListener("resize", this.getWindowHeight);
    this.getWindowHeight();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.getWindowHeight);
  },
  methods: {
    processConfirm(){
      console.log('processConfirm fired');
      if(this.processingMode == -100){
        console.log('er1');
        this.detachTaskFromBoxAfter();
      }else if(this.processingMode == 6546){
        console.log('er2');
        this.deleteTask();
      } else {
        console.log('er3');
        this.updateTaskInherited(this.processingObj, 2);
      }
                  
    },
    showMenu(event, item){
      this.isMenuVisible = true;
      this.menuPosition = { x: event.clientX, y: event.clientY };
      this.selectedItem = item;
    },
    handleMenuItemClick(action){
      if (this.selectedItem) {
        if(action=='detail'){
          this.showDetail(this.selectedItem);
        } else if(action=='edit'){
          
        } else if(action=='delete'){
          this.processingObj = { id: this.selectedItem.id, module: "task" };
          this.processingMode= 6546;
          this.busy = true;
        }
      }
      this.isMenuVisible = false;
    },
    deleteTask() {
      this.processing = true;
      request({
        api: { method: "GET", url: "Task/DeleteBefore" },
        params: { id: this.processingObj.id },
        store: this.$store,
      }).then((res) => {
        this.processing = false;
        if (res != false) {
          if (res.data.result == 1) {
            this.processing = true;
            request({
              api: { method: "POST", url: "Task/Delete" },
              params: { id: this.processingObj.id },
              store: this.$store,
            }).then((res) => {
              this.processing = false;
              if (res != false) {
                if (res.data.result == 1) {
                  this.taskDeleted(this.processingObj.id);
                  this.processingObj=this.processingObj.id;
                  this.$nextTick(()=>{
                    this.detachTaskFromBoxAfter();
                  });
                  this.busy = false;
                  this.$bvToast.toast("Амжилттай", {
                    title: "Амжилттай",
                    autoHideDelay: 5000,
                    appendToast: true,
                  });
                  this.visibleChanged(false);
                  this.$emit("on-task-delete", res.data.id);
                } else {
                  this.$bvToast.toast(`${res.data.info}`, {
                    title: "Амжилтгүй",
                    autoHideDelay: 5000,
                    appendToast: true,
                  });
                }
              }
            });
          } else {
            this.busy = false;
            this.processing = false;
            this.$bvToast.toast(`${res.data.info}`, {
              title: "Амжилтгүй",
              autoHideDelay: 5000,
              appendToast: true,
            });
          }
        } else {
          this.$bvToast.toast(`${res.data.info}`, {
            title: "Амжилтгүй",
            autoHideDelay: 5000,
            appendToast: true,
          });
        }
      });
    },

    addItem(){
      this.showFinder();
    },
    ...mapActions(["handleUserInfoModal"]),
    postBoxInTaskOption(){
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "Box/PostBoxInTaskOption" },
        data: {
          taskId: this.pointObj.taskId,
          boxId: this.box.id,
          count: this.pointObj.count,
          price: this.pointObj.price
        },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.pointObj.modal= false;
          this.init();
          // console.log('PostBoxInTaskOption', res);
        }
      });
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;
      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    getWindowHeight() {
      if (
        this.detailSetting.boxSetting.autoHeight != undefined &&
        this.detailSetting.boxSetting.autoHeight
      ) {
        this.detailSetting.boxSetting.listSetting.height = "auto";
      } else {
        let minusHeight = this.detailSetting.boxSetting.hideToolbar ? 165 : 220;
        minusHeight = minusHeight - (this.detailSetting.hideToolbar ? 60 : 0);
        this.detailSetting.boxSetting.listSetting.height =
          window.innerHeight - minusHeight + "px";
      }
    },
    initFields() {
      getListFields({
        params: { objectTypeId: this.box.ot },
        store: this.$store
      }).then(res => {
        if (res != false) {
          let allSpan = res.data.fields.reduce(
            (sum, { span }) => sum + span,
            0
          );
          this.fields = res.data.fields.map(e => {
            e.span = parseInt((e.span * 95) / allSpan, 10);
            return e;
          });
          this.init();
        }
      });
    },
    reInit(e) {
      this.init(e);
    },
    showDetail(t) {
      if (!this.detailSetting.boxSetting.listSetting.disableDetail)
        this.$emit("on-detail", t, 80);
    },
    taskDeleted(id) {
      //this.tasks
      let i = this.tasks.map(st => st.id).indexOf(id);
      this.tasks.splice(i, 1);
      this.tasksCount = this.tasksCount - 1;
    },
    init(force) {
      this.toggleBodyClass("addClass", "dynamic-locker");
      let self = this;
      this.tasks = [];
      if (force) {
        this.pager.current = 1;
      }
      //this.tasksCount = 0;
      //let pager=this.pager.current;
      //this.fetched= false;
      // coreBoxInTaskList({
      //   data: {
      //     id: this.box.id,
      //     skip: ((this.pager.current - 1) * this.pager.perPage),
      //     size: this.pager.perPage,
      //     model: this.coreSearchModel
      //   },
      //   store: this.$store
      // })
      request({
        api: { method: "POST", url: "taskCore/CoreBoxInTaskList" },
        data: {
          id: this.box.id,
          skip: (this.pager.current - 1) * this.pager.perPage,
          size: this.pager.perPage,
          model: this.coreSearchModel
        },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if(res!=false){
          // console.log('res', res);
          this.$emit("update-box-count", {
            boxId: this.box.id,
            count: res.data.tasksCount
          });
        }
        if (res.data.tasks.length > 0) {
          res.data.tasks = res.data.tasks.map(function(e) {
            e.selcd = false;
            return e;
          });
          //first task ot => daraah uyed
          //473, 474
          if (
            res.data.tasks[0].objectTypeId == 473 ||
            res.data.tasks[0].objectTypeId == 474
          ) {
            this.tasks = res.data.tasks.map(function(e) {
              //st1 talbariig taslalaar array bolgood
              //tend bgag n remove hiine esvel neg tiim disabled utga tavina vetmedmeesbul,vetmedpharma
              e.hidden =
                e.st1 != null &&
                hasOneOf(e.st1.split(","), self.$store.state.user.access);
              return e;
            });
          } else {
            this.tasks = res.data.tasks;
          }

          request({
            api: { method: "POST", url: "column/getColumnsByProjectId" },
            params: {
              projectId: this.tasks[0].projectId
            },
            store: this.$store
          }).then(res => {
            if (res != false) {
              this.projectStat = res.data;
            }
          });
        }
        this.tasksCount = res.data.tasksCount;
        this.allCount = res.data.allCount;
        this.fetched = true;
        //console.log('stp0');
        if(this.prms.ifEmptyHide!=undefined && this.prms.ifEmptyHide==true){
          //console.log('stp1');
          if(this.allCount<=0 && this.fetched){
            this.ifEmptyHide= true;
          }
        }
        // console.log('box load before', res.data);
        this.$emit("box-loaded", res.data);
      });
    },
    taskDetail(id) {
      taskInheritedDetail({
        params: { id: id, sourceFlag: 1 },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.task = res.data.task;
        }
      });
    },
    updateField(e) {
      if(e.mode==59){
        this.pointObj.taskId=e.taskId;

        this.toggleBodyClass("addClass", "dynamic-locker");
        request({
          api: { method: "POST", url: "Box/GetBoxInTaskOption" },
          data: {
            taskId: this.pointObj.taskId,
            boxId: this.box.id
          },
          store: this.$store
        }).then(res => {
          this.toggleBodyClass("removeClass", "dynamic-locker");
          if (res != false) {
            this.pointObj.count= res.data.taskBoxInTask.count;
            this.pointObj.price= res.data.taskBoxInTask.price;
            this.pointObj.modal=true;
          }
        });
      }
      else{
        getInheritedTask({ params: { id: e.taskId }, store: this.$store }).then(
          res => {
            var _model = res.data.task;
            if (e.mode == 0) {
              _model[e.field.field] = !(e.value === true);
              this.updateTaskInherited(_model, 0);
            } else if (e.mode == 2) {
              _model[e.field.field] = e.value;
              this.processingObj = _model;
              this.busy = true;
            } else if (e.mode == 22) {
              _model[e.field.field] = e.value;
              this.updateTaskInherited(_model, 22);
            } else if (e.mode == 888) {
              _model[e.field] = e.value;
              this.updateTaskInherited(_model, e.mode);
            } else if (e.mode == 1) {
              //_model[e.field] = e.value;
              //this.updateTaskInherited(_model, e.mode);
              this.init();
            }
          }
        );
      }
    },
    updateTaskInherited(obj, mode) {
      let self = this;
      if (!this.hasPermission(["admin"])) {
        if (mode == 2 || mode == 22) {
          this.processing = true;
          if (
            this.parentTask.user != null &&
            this.parentTask.user.userId == this.$store.state.user.userId
          ) {
            if (!(this.parentTask.im != null && this.parentTask.im.pinIs)) {
              setTimeout(() => {
                self.$bvToast.toast("Үйлдлийг гүйцэтгэх боломжгүй.", {
                  title: "Мэдэгдэл",
                  autoHideDelay: 5000,
                  appendToast: false,
                  variant: "warning",
                  toaster: "b-toaster-bottom-left"
                });
                self.processing = false;
                self.busy = false;
              }, 500);

              return;
            }
          } else {
             if (!(obj.im != null && obj.im.pinIs)) {
              setTimeout(() => {
                self.$bvToast.toast("Үйлдлийг гүйцэтгэх боломжгүй...", {
                  title: "Мэдэгдэл",
                  autoHideDelay: 5000,
                  appendToast: false,
                  variant: "warning",
                  toaster: "b-toaster-bottom-left"
                });
                self.processing = false;
                self.busy = false;
              }, 500);

              return;
            }

            // setTimeout(() => {
            //   self.$bvToast.toast("Үйлдлийг гүйцэтгэх боломжгүй", {
            //     title: "Мэдэгдэл",
            //     autoHideDelay: 5000,
            //     appendToast: false,
            //     variant: "warning",
            //     toaster: "b-toaster-bottom-left"
            //   });
            //   self.processing = false;
            //   self.busy = false;
            // }, 500);

            // return;
          }
        }
      }

      postInheritedTask({
        data: { model: obj },
        store: this.$store
      }).then(res => {
        if (res != false) {
          if (mode == 888) {
            this.mediaFinder.show = false;
            this.init();
          } else if (mode == 2) {
            this.processing = false;
            this.busy = false;
            this.init();
          } else if (mode == 22) {
            this.init();
          } else if (mode == 0) {
            this.init();
          } else if (mode == 1) {
            this.init();
          }
        }
      });
    },
    hasPermission(perrArr) {
      return hasOneOf(perrArr, this.$store.state.user.access);
    },
    showFinder(e) {
      if (!this.hasPermission(["admin"])) {
        if (
          this.parentTask.user != null &&
          this.parentTask.user.userId == this.$store.state.user.userId
        ) {
          if (!(this.parentTask.im != null && this.parentTask.im.pinIs)) {
            this.$bvToast.toast("Үйлдлийг гүйцэтгэх боломжгүй", {
              title: "Мэдэгдэл",
              autoHideDelay: 5000,
              appendToast: false,
              variant: "warning",
              toaster: "b-toaster-bottom-left"
            });
            return;
          }
        } else {
          this.$bvToast.toast("Үйлдлийг гүйцэтгэх боломжгүй", {
            title: "Мэдэгдэл",
            autoHideDelay: 5000,
            appendToast: false,
            variant: "warning",
            toaster: "b-toaster-bottom-left"
          });
          return;
        }
      }
      this.linkAttaching.taskId = e.taskId;
      this.linkAttaching.field = e.field;
      this.mediaFinder.show = true;
    },
    fileAttached(e) {
      this.updateField({
        mode: 888,
        value: e,
        taskId: this.linkAttaching.taskId,
        field: this.linkAttaching.field
      });
    },
    taskAttached(e) {
      request({
        api: { method: "POST", url: "Box/ConnectTaskToBox" },
        data: { taskId: e.id, boxId: this.box.id },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.init();
        }
      });
    },
    detachTaskFromBox(tid) {
      this.processingObj = tid;
      this.processingMode = -100;
      this.busy = true;
    },
    detachTaskFromBoxAfter() {
      this.processing = true;

      request({
        api: { method: "POST", url: "Box/DisconnectTaskFromBox" },
        data: { taskId: this.processingObj, boxId: this.box.id },
        store: this.$store
      }).then(res => {
        this.processingMode = 0;
        this.processing = false;
        this.busy = false;

        if (res != false) {
          this.init();
        }
      });
    },
    boxRowSelect(t) {
      this.tasks = this.tasks.map(function(e) {
        e.selcd = e.id == t.id;
        return e;
      });
    },
    pageChanged(e) {
      this.pager.current = e;
      this.init();
    },
    showBoxFilter() {
      getSearchFields({
        params: { objectTypeId: this.box.ot },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.boxFilter.searches = res.data.fields.map(e =>
            Object.assign(e, { val: "" })
          );
          this.boxFilter.modal = true;
        }
      });
    },
    filterCoreBox(reset) {
      if (reset) {
        this.$refs.srchFields.reset();
      } else {
        this.$refs.srchFields.filter();
      }
    },
    exportBoxHandle() {
      this.$refs.srchFields.export();
    },
    exportBox(e) {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "taskCore/coreBoxInTaskExport" },
        data: { id: this.box.id, model: e, skip: 0, size: 99999 },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.boxFilter.modal = false;
          this.$emit("on-attach", res.data.file.id);
        }
      });
    },
    onSearchFired(e) {
      this.coreSearchModel = e;
      this.init(true);
    }
  }
};
</script>
